/* PDPNEW — assets/pdp-new.js (dev theme only). Modules bound via data-pdp-module. */
(function () {
  'use strict';
  if (window.PDPNew) return;

  var PDPNew = {
    version: '1.2.2-sticky-form-fix',
    modules: {},
    mq: {
      mobile: window.matchMedia('screen and (max-width: 699px)'),
      tablet: window.matchMedia('screen and (min-width: 700px) and (max-width: 999px)'),
      desktop: window.matchMedia('screen and (min-width: 1000px)'),
      reducedMotion: window.matchMedia('(prefers-reduced-motion: reduce)')
    },
    register: function (name, init) { this.modules[name] = init; },
    initElement: function (el) {
      var name = el.getAttribute('data-pdp-module');
      var init = this.modules[name];
      if (!init || el.__pdpNewInit) return;
      el.__pdpNewInit = true;
      try { init(el, this); } catch (err) { console.error('[PDPNew] module "' + name + '" failed', err); }
    },
    initWithin: function (root) {
      var self = this;
      if (!root) return;
      if (root.matches && root.matches('[data-pdp-module]')) self.initElement(root);
      root.querySelectorAll('[data-pdp-module]').forEach(function (el) { self.initElement(el); });
    },
    init: function () {
      this.initWithin(document);
      document.dispatchEvent(new CustomEvent('pdp-new:ready', { detail: { version: this.version } }));
    }
  };
  window.PDPNew = PDPNew;

  PDPNew.openCart = function () {
    var drawer = document.getElementById('cart-drawer') || document.querySelector('cart-drawer');
    if (drawer && typeof drawer.show === 'function') { drawer.show(); return true; }
    return false;
  };

  PDPNew.addToCart = function (items) {
    var store = window.Everpret && window.Everpret.cartStore;
    var done;
    if (store && typeof store.addItems === 'function') {
      done = store.addItems(items, { baseEvent: 'variant:add' });
    } else {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      done = fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        return r.json().then(function (json) {
          if (!r.ok) { var err = new Error(json.description || 'Could not add to cart'); err.response = json; throw err; }
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          return json;
        });
      });
    }
    return done.then(function (res) { window.setTimeout(PDPNew.openCart, 150); return res; });
  };

  document.addEventListener('click', function (event) {
    var opener = event.target.closest && event.target.closest('[data-pdp-modal-open]');
    if (opener) {
      var dialog = document.getElementById(opener.getAttribute('data-pdp-modal-open'));
      if (dialog && typeof dialog.showModal === 'function') { event.preventDefault(); dialog.showModal(); }
      return;
    }
    var closer = event.target.closest && event.target.closest('[data-pdp-modal-close]');
    if (closer) { var d = closer.closest('dialog'); if (d) d.close(); return; }
    if (event.target.matches && event.target.matches('dialog.pdp-new__modal, dialog.pdp-new__lightbox')) event.target.close();
  });

  PDPNew.register('product', function (root) {
    var dataEl = root.querySelector('script[data-pdp-variants]');
    var variants = [];
    try { variants = JSON.parse(dataEl ? dataEl.textContent : '[]'); } catch (e) { variants = []; }
    var form = document.getElementById(root.getAttribute('data-form-id'));
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var optionSets = [].slice.call(root.querySelectorAll('[data-pdp-option]'));

    function all(sel) { return [].slice.call(root.querySelectorAll(sel)); }
    function setText(sel, value) { all(sel).forEach(function (el) { el.textContent = value; }); }
    function setHidden(sel, hidden) { all(sel).forEach(function (el) { el.hidden = hidden; }); }
    function selectedOptions() {
      return optionSets.map(function (fs) { var c = fs.querySelector('input:checked'); return c ? c.value : null; });
    }
    function findVariant(options) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], match = true;
        for (var j = 0; j < options.length; j++) {
          if (options[j] !== null && v.options[j] !== options[j]) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }
    function markSoldOut() {
      if (optionSets.length !== 1) return;
      optionSets[0].querySelectorAll('input').forEach(function (input) {
        var v = findVariant([input.value]);
        var wrap = input.closest('.pdp-new__value');
        if (wrap) wrap.classList.toggle('is-soldout', !v || !v.available);
      });
    }
    function update(v) {
      var atcs = all('[data-pdp-atc]');
      if (!v) {
        atcs.forEach(function (b) { b.disabled = true; });
        setText('[data-pdp-atc-label]', root.getAttribute('data-str-unavailable') || 'Unavailable');
        setHidden('[data-pdp-atc-price]', true);
        return;
      }
      if (idInput) idInput.value = v.id;
      setText('[data-pdp-price-now]', v.price);
      setText('[data-pdp-price-was]', v.compare || '');
      setText('[data-pdp-price-off]', v.pct ? (v.pct + '% OFF') : '');
      setText('[data-pdp-save]', v.save || '');
      setHidden('[data-pdp-price-was]', !v.compare);
      setHidden('[data-pdp-price-off]', !v.pct);
      setHidden('[data-pdp-saveline-pill]', !v.save);
      all('[data-pdp-stock]').forEach(function (el) {
        el.classList.toggle('is-soldout', !v.available);
        var txt = el.querySelector('[data-pdp-stock-text]');
        if (txt) txt.textContent = v.stock;
      });
      atcs.forEach(function (b) { b.disabled = !v.available; });
      setText('[data-pdp-atc-label]', v.available ? (root.getAttribute('data-str-add') || 'Add to Cart') : (root.getAttribute('data-str-soldout') || 'Sold out'));
      setText('[data-pdp-atc-price]', v.available ? ' — ' + v.price : '');
      setHidden('[data-pdp-atc-price]', !v.available);
      optionSets.forEach(function (fs, i) {
        var label = fs.querySelector('[data-pdp-option-value]');
        if (label) label.textContent = v.options[i];
      });
      if (window.history && window.history.replaceState && root.hasAttribute('data-update-url')) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      document.dispatchEvent(new CustomEvent('pdp-new:variant-change', { detail: { variant: v, sectionId: root.getAttribute('data-section-id') } }));
    }
    root.addEventListener('change', function (event) {
      if (event.target.closest('[data-pdp-option]')) update(findVariant(selectedOptions()));
    });
    markSoldOut();

    var qtyInput = root.querySelector('[data-pdp-qty-input]');
    function clampQty(n) {
      if (!qtyInput) return 1;
      var min = parseInt(qtyInput.min, 10) || 1;
      var max = parseInt(qtyInput.max, 10) || 99;
      return Math.max(min, Math.min(max, n || min));
    }
    root.addEventListener('click', function (event) {
      var step = event.target.closest('[data-pdp-qty]');
      if (!step || !qtyInput) return;
      qtyInput.value = clampQty((parseInt(qtyInput.value, 10) || 1) + parseInt(step.getAttribute('data-pdp-qty'), 10));
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    });
    if (qtyInput) qtyInput.addEventListener('change', function () { qtyInput.value = clampQty(parseInt(qtyInput.value, 10)); });

    var perso = root.querySelector('[data-pdp-perso-toggle]');
    var panel = root.querySelector('[data-pdp-perso-panel]');
    if (perso && panel) {
      var initials = panel.querySelector('input[name="Initials"]');
      var syncPerso = function () {
        panel.hidden = !perso.checked;
        if (initials) { initials.required = perso.checked; initials.disabled = !perso.checked; }
      };
      perso.addEventListener('change', function () { syncPerso(); if (perso.checked && initials) initials.focus(); });
      if (initials) initials.addEventListener('input', function () { initials.value = initials.value.replace(/[^a-zA-Z]/g, '').toUpperCase().slice(0, 2); });
      syncPerso();
    }

    if (form && !window.customElements.get('product-form')) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var btn = form.querySelector('[data-pdp-atc]');
        if (btn) btn.setAttribute('aria-busy', 'true');
        PDPNew.addToCart([{ id: Number(idInput.value), quantity: clampQty(parseInt(qtyInput && qtyInput.value, 10)) }])
          .catch(function (err) {
            var box = root.querySelector('[data-pdp-form-error]');
            if (box) box.textContent = (err && err.message) || 'Could not add to cart';
          })
          .finally(function () { if (btn) btn.removeAttribute('aria-busy'); });
      });
    }
  });

  PDPNew.register('gallery', function (g) {
    var track = g.querySelector('[data-pdp-track]');
    if (!track) return;
    var rail = g.querySelector('[data-pdp-rail]');
    var slides = [].slice.call(g.querySelectorAll('[data-pdp-slide]'));
    var thumbs = [].slice.call(g.querySelectorAll('[data-pdp-thumb]'));
    var dotsEl = g.querySelector('[data-pdp-dots]');
    var lightbox = g.querySelector('[data-pdp-lightbox]');
    var visible = [], current = 0, ticking = false;

    function padLeft() { return parseFloat(window.getComputedStyle(track).paddingLeft) || 0; }
    function buildDots() {
      if (!dotsEl) return;
      dotsEl.innerHTML = '';
      if (visible.length < 2) return;
      visible.forEach(function (s, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'pdp-new__dot';
        b.setAttribute('aria-label', 'Go to image ' + (i + 1));
        b.addEventListener('click', function () { goTo(i); });
        dotsEl.appendChild(b);
      });
    }
    function setActive(i) {
      current = i;
      var active = visible[i];
      if (dotsEl) [].forEach.call(dotsEl.children, function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      thumbs.forEach(function (t) {
        var on = !!active && t.getAttribute('data-media-id') === active.getAttribute('data-media-id');
        t.setAttribute('aria-current', on ? 'true' : 'false');
        if (on && rail) {
          var top = t.offsetTop - rail.offsetTop, bottom = top + t.offsetHeight;
          if (top < rail.scrollTop || bottom > rail.scrollTop + rail.clientHeight) rail.scrollTop = top - 10;
        }
      });
      visible.forEach(function (s, k) {
        if (k === i) return;
        var video = s.querySelector('video');
        if (video && !video.paused) video.pause();
      });
    }
    function goTo(i, instant) {
      var s = visible[i];
      if (!s) return;
      track.scrollTo({ left: s.offsetLeft - padLeft(), behavior: instant || PDPNew.mq.reducedMotion.matches ? 'auto' : 'smooth' });
      setActive(i);
    }
    function refresh() {
      visible = slides.filter(function (s) { return !s.hidden; });
      buildDots();
      track.scrollLeft = 0;
      setActive(0);
    }
    function setGroup(key) {
      var hasGroup = slides.some(function (s) { return s.getAttribute('data-group') === key; });
      function shouldShow(el) {
        if (!hasGroup) return true;
        var grp = el.getAttribute('data-group');
        return grp === key || grp === 'shared';
      }
      slides.forEach(function (s) { s.hidden = !shouldShow(s); });
      thumbs.forEach(function (t) { t.hidden = !shouldShow(t); });
      if (!slides.some(function (s) { return !s.hidden; })) {
        slides.forEach(function (s) { s.hidden = false; });
        thumbs.forEach(function (t) { t.hidden = false; });
      }
      refresh();
    }
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        var x = track.scrollLeft + padLeft(), best = 0, bestDist = Infinity;
        visible.forEach(function (s, i) {
          var d = Math.abs(s.offsetLeft - x);
          if (d < bestDist) { bestDist = d; best = i; }
        });
        if (best !== current) setActive(best);
      });
    }, { passive: true });
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var id = t.getAttribute('data-media-id');
        for (var i = 0; i < visible.length; i++) {
          if (visible[i].getAttribute('data-media-id') === id) { goTo(i); break; }
        }
      });
    });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(Math.min(visible.length - 1, current + 1)); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(Math.max(0, current - 1)); }
    });
    function openLightbox(index) {
      if (!lightbox || typeof lightbox.showModal !== 'function') return;
      var scroller = lightbox.querySelector('[data-pdp-lightbox-scroll]');
      scroller.innerHTML = '';
      var target = null;
      visible.forEach(function (s, i) {
        var src = s.getAttribute('data-zoom-src');
        if (!src) return;
        var img = document.createElement('img');
        img.className = 'pdp-new__lightbox-img';
        img.src = src;
        img.alt = s.getAttribute('data-alt') || '';
        img.loading = i === index ? 'eager' : 'lazy';
        scroller.appendChild(img);
        if (i === index) target = img;
      });
      lightbox.showModal();
      if (target) {
        var place = function () { scroller.scrollTop = target.offsetTop - 56; };
        if (target.complete) place(); else target.addEventListener('load', place, { once: true });
      }
    }
    g.addEventListener('click', function (e) {
      if (e.target.closest('[data-pdp-zoom]')) { openLightbox(current); return; }
      var slide = e.target.closest('.pdp-new__slide--zoomable');
      if (slide && PDPNew.mq.desktop.matches) {
        var i = visible.indexOf(slide);
        if (i > -1) openLightbox(i);
      }
    });
    document.addEventListener('pdp-new:variant-change', function (e) {
      if (!e.detail || e.detail.sectionId !== g.getAttribute('data-section-id')) return;
      var v = e.detail.variant;
      if (g.getAttribute('data-grouped') === 'true' && v.group) setGroup(v.group);
      if (v.media) {
        for (var i = 0; i < visible.length; i++) {
          if (visible[i].getAttribute('data-media-id') === String(v.media)) { goTo(i, true); break; }
        }
      }
    });
    visible = slides.filter(function (s) { return !s.hidden; });
    buildDots();
    setActive(0);
  });

  PDPNew.register('reviews', function (root) {
    var btn = root.querySelector('[data-pdp-readall]');
    var widget = root.querySelector('[data-pdp-rev-widget]');
    if (!btn || !widget) return;
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var open = widget.hidden;
      widget.hidden = !open;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      var label = btn.querySelector('[data-pdp-readall-label]');
      if (label) label.textContent = open ? (btn.getAttribute('data-label-close') || 'Show fewer reviews') : (btn.getAttribute('data-label-open') || 'Read all reviews');
      if (open) widget.scrollIntoView({ behavior: PDPNew.mq.reducedMotion.matches ? 'auto' : 'smooth', block: 'start' });
    });
  });

  PDPNew.register('quick-add', function (root) {
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-pdp-card-add]');
      if (!btn || btn.disabled) return;
      var original = btn.getAttribute('data-label') || btn.textContent;
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      PDPNew.addToCart([{ id: Number(btn.getAttribute('data-variant-id')), quantity: 1 }])
        .then(function () {
          btn.classList.add('is-added');
          btn.textContent = btn.getAttribute('data-label-added') || 'Added';
          window.setTimeout(function () { btn.classList.remove('is-added'); btn.textContent = original; btn.disabled = false; }, 2400);
        })
        .catch(function () { btn.textContent = btn.getAttribute('data-label-error') || 'Try again'; btn.disabled = false; })
        .finally(function () { btn.removeAttribute('aria-busy'); });
    });
  });

  PDPNew.register('recent', function (el) {
    var loaded = false;
    function load() {
      if (loaded) return;
      loaded = true;
      var ids = [];
      try { ids = JSON.parse(localStorage.getItem('theme:recently-viewed-products') || '[]'); } catch (e) { ids = []; }
      var current = Number(el.getAttribute('data-product-id'));
      var limit = parseInt(el.getAttribute('data-limit'), 10) || 4;
      ids = ids.map(Number).filter(function (id) { return id && id !== current; }).slice(0, limit);
      if (!ids.length) return;
      var url = el.getAttribute('data-search-url') + '?type=product&options%5Bunavailable_products%5D=last&q=' +
        encodeURIComponent(ids.map(function (id) { return 'id:' + id; }).join(' OR ')) +
        '&section_id=' + encodeURIComponent(el.getAttribute('data-section'));
      fetch(url, { headers: { Accept: 'text/html' } })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var cards = [].slice.call(doc.querySelectorAll('[data-pdp-card]'));
          if (!cards.length) return;
          cards.sort(function (a, b) {
            return ids.indexOf(Number(a.getAttribute('data-product-id'))) - ids.indexOf(Number(b.getAttribute('data-product-id')));
          });
          var list = el.querySelector('[data-pdp-recent-list]');
          if (!list) return;
          list.innerHTML = '';
          cards.forEach(function (c) { list.appendChild(document.importNode(c, true)); });
          list.hidden = false;
          var empty = el.querySelector('[data-pdp-recent-empty]');
          if (empty) empty.hidden = true;
        })
        .catch(function () { loaded = false; });
    }
    el.addEventListener('toggle', function () { if (el.open) load(); });
    if (el.open) load();
  });

  /* sticky-atc — mobile/tablet: always visible. Desktop: appears after buy box scrolls out (Zouk flow). */
  PDPNew.register('sticky-atc', function (bar) {
    var main = document.querySelector('.pdp-new--main[data-form-id]');
    var formId = main ? main.getAttribute('data-form-id') : '';
    var form = formId ? document.getElementById(formId) : null;
    var btn = bar.querySelector('[data-pdp-sticky-atc]');
    if (!main || !form || !btn) { bar.hidden = true; return; }

    // NOTE: never use form.id here — the form contains <input name="id">, so form.id returns that input.
    btn.setAttribute('form', formId);
    var mainAtc = form.querySelector('[data-pdp-atc]');
    var qtyInput = form.querySelector('[data-pdp-qty-input]');
    var qtyOut = bar.querySelector('[data-pdp-sticky-qty]');
    var colorIdx = parseInt(bar.getAttribute('data-color-index'), 10);
    var thumbs = {};
    try { thumbs = JSON.parse(bar.querySelector('script[data-pdp-sticky-thumbs]').textContent); } catch (e) { thumbs = {}; }

    function setShown(on) {
      bar.classList.toggle('is-visible', on);
      if (on) { bar.removeAttribute('inert'); bar.setAttribute('aria-hidden', 'false'); }
      else { bar.setAttribute('inert', ''); bar.setAttribute('aria-hidden', 'true'); }
      document.body.classList.toggle('pdp-new-has-sticky', on);
    }

    var observer = null;
    function useScrollTrigger() {
      var target = main.querySelector('.pdp-new__purchase') || mainAtc;
      if (!target || !('IntersectionObserver' in window)) { setShown(true); return; }
      setShown(false);
      observer = new IntersectionObserver(function (entries) {
        var e = entries[0];
        setShown(!e.isIntersecting && e.boundingClientRect.top < 0);
      });
      observer.observe(target);
    }
    function updateVisibilityMode() {
      if (PDPNew.mq.desktop.matches) { if (!observer) useScrollTrigger(); }
      else { if (observer) { observer.disconnect(); observer = null; } setShown(true); }
    }
    updateVisibilityMode();
    if (PDPNew.mq.desktop.addEventListener) PDPNew.mq.desktop.addEventListener('change', updateVisibilityMode);

    function syncQty() { if (qtyOut && qtyInput) qtyOut.textContent = qtyInput.value; }
    bar.addEventListener('click', function (e) {
      var step = e.target.closest('[data-pdp-sticky-step]');
      if (!step || !qtyInput) return;
      var min = parseInt(qtyInput.min, 10) || 1, max = parseInt(qtyInput.max, 10) || 99;
      var n = (parseInt(qtyInput.value, 10) || 1) + parseInt(step.getAttribute('data-pdp-sticky-step'), 10);
      qtyInput.value = Math.max(min, Math.min(max, n));
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      syncQty();
    });
    if (qtyInput) qtyInput.addEventListener('change', syncQty);
    syncQty();
    if (mainAtc) btn.disabled = mainAtc.disabled;

    document.addEventListener('pdp-new:variant-change', function (e) {
      if (!e.detail || e.detail.sectionId !== main.getAttribute('data-section-id')) return;
      var v = e.detail.variant;
      var price = bar.querySelector('[data-pdp-sticky-price]');
      var was = bar.querySelector('[data-pdp-sticky-was]');
      var name = bar.querySelector('[data-pdp-sticky-variant]');
      var label = bar.querySelector('[data-pdp-sticky-label]');
      var thumb = bar.querySelector('[data-pdp-sticky-thumb]');
      if (price) price.textContent = v.price;
      if (was) { was.textContent = v.compare || ''; was.hidden = !v.compare; }
      if (name) name.textContent = colorIdx >= 0 ? v.options[colorIdx] : (v.title === 'Default Title' ? '' : v.title);
      if (thumb && thumbs[v.id]) thumb.src = thumbs[v.id];
      btn.disabled = !v.available;
      if (label) label.textContent = v.available ? (bar.getAttribute('data-str-add') || 'Add to Cart') : (bar.getAttribute('data-str-soldout') || 'Sold out');
    });
  });

  document.addEventListener('shopify:section:load', function (event) { PDPNew.initWithin(event.target); });
  document.addEventListener('variant:change', function () { window.requestAnimationFrame(function () { PDPNew.initWithin(document); }); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { PDPNew.init(); });
  else PDPNew.init();
})();